import PreLoaderView from './PreLoader.view';
export default PreLoaderView;
